export default __webpack_public_path__ + "static/undraw_Personal_file_re_5joy-f35b7ca16847affe15395bb14d82a859.png";